import { render, staticRenderFns } from "./RescheduleRoute.vue?vue&type=template&id=c24ed58c&"
import script from "./RescheduleRoute.vue?vue&type=script&lang=ts&"
export * from "./RescheduleRoute.vue?vue&type=script&lang=ts&"
import style0 from "./RescheduleRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports